import { render, staticRenderFns } from "./CorrectOrderContent.vue?vue&type=template&id=7763397b&scoped=true&"
import script from "./CorrectOrderContent.vue?vue&type=script&lang=js&"
export * from "./CorrectOrderContent.vue?vue&type=script&lang=js&"
import style0 from "./CorrectOrderContent.vue?vue&type=style&index=0&id=7763397b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7763397b",
  null
  
)

export default component.exports